import api from '../lib/api';
import type {
  Campaign,
  CampaignFilters,
  CreateCampaignRequest,
  UpdateCampaignRequest,
  UpdateCampaignStatusRequest
} from '../types/campaign';
import type { PaginatedResponse } from '../types/api';

export const campaignService = {
  getAll: async (
    page = 1,
    limit = 20,
    filters: CampaignFilters = {}
  ): Promise<PaginatedResponse<Campaign>> => {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    });

    if (filters.search) params.append('search', filters.search);
    if (filters.status) params.append('status', filters.status);
    if (filters.template_id) params.append('template_id', filters.template_id.toString());
    if (filters.whatsapp_id) params.append('whatsapp_id', filters.whatsapp_id.toString());
    if (filters.assistant_id) params.append('assistant_id', filters.assistant_id.toString());
    if (filters.start_date_from) params.append('start_date_from', filters.start_date_from);
    if (filters.start_date_to) params.append('start_date_to', filters.start_date_to);
    if (filters.end_date_from) params.append('end_date_from', filters.end_date_from);
    if (filters.end_date_to) params.append('end_date_to', filters.end_date_to);
    if (filters.active_only) params.append('active_only', 'true');

    const response = await api.get(`/mkt-campaigns?${params}`);
    return response.data;
  },

  getById: async (id: number): Promise<Campaign> => {
    const response = await api.get(`/mkt-campaigns/${id}`);
    return response.data;
  },

  create: async (data: CreateCampaignRequest): Promise<Campaign> => {
    const response = await api.post('/mkt-campaigns', data);
    return response.data;
  },

  update: async (id: number, data: UpdateCampaignRequest): Promise<Campaign> => {
    const response = await api.put(`/mkt-campaigns/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/mkt-campaigns/${id}`);
  },

  updateStatus: async (id: number, data: UpdateCampaignStatusRequest): Promise<Campaign> => {
    const response = await api.patch(`/mkt-campaigns/${id}/status`, data);
    return response.data;
  },
};
